import React from 'react'

import "./section2.css"

import ux from "../../../assets/images/ux.svg"
import mouse from "../../../assets/images/mouse.svg"
import alarm from "../../../assets/images/alarm.svg"
import phone from "../../../assets/images/phone.svg"

const Section2 = () => {
    return (
        <section className='section2'>
            <h1 className='section2_heading'>Get into it, right on the app.</h1>
            <div className="frame--group">
                <div className="frame--content">
                    <div className="frame--content__inner">
                        <img src={ux} alt="ux icon" />
                        <h1>Soft user experience</h1>
                        <p>
                            Sharing interesting or captivating
                            content you find on the internet
                            directly into pipes you have created
                            on MyPipe app happens in just two clicks.
                            simple & easy.
                        </p>
                    </div>
                </div>
                <div className="frame--content">
                    <div className="frame--content__inner">
                        <img src={mouse} alt="mouse icon" />
                        <h1>Native look</h1>
                        <p>
                            MyPipe app understands content types
                            based on the platform it is coming
                            from. i.e, when you share a tweet or
                            instagram post, it displays them just
                            the way they look on their individual
                            platform. Cool, yeah?
                        </p>
                    </div>
                </div>
                <div className="frame--content">
                    <div className="frame--content__inner">
                        <img src={alarm} alt="alarm icon" />
                        <h1>Remainders</h1>
                        <p>
                            Set reminders on articles, tweets, clips,
                            etc. you might want to read or revisit
                            later. Set a specific date and time,
                            and you’ll get a notification.
                        </p>
                    </div>
                </div>
                <div className="frame--content">
                    <div className="frame--content__inner">
                        <img src={phone} alt="alarm icon" />
                        <h1>Right in the app.</h1>
                        <p>
                            Watch saved videos, read articles,
                            go through your bookmarked tweets,
                            or saved IG posts, etc. right in
                            the app.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Section2
